import { NavLink } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthProvider';
import styles from './Sidebar.module.scss';

interface SidebarProps {
    isMobileOpen: boolean;
    onMobileClose: () => void;
    onThemeToggle?: () => void;
    isDarkTheme?: boolean;
}

const navGroups = [
    {
        label: 'Overview',
        items: [{ path: '/dashboard', label: 'Dashboard', icon: '◫' }],
    },
    {
        label: 'My Finances',
        items: [
            { path: '/assets', label: 'Assets', icon: '🏦' },
            { path: '/cashflows', label: 'Income & Expenses', icon: '↕' },
            { path: '/goals', label: 'Goals', icon: '◎' },
        ],
    },
    {
        label: 'Planning & Tax',
        items: [
            { path: '/simulator', label: 'Simulator', icon: '📈' },
            { path: '/tax', label: 'Tax Deep-Dive', icon: '🧾' },
            { path: '/residency', label: 'Residency', icon: '🌐' },
            { path: '/pensions', label: 'Pensions', icon: '🏛️' },
            { path: '/healthcare-bridge', label: 'Healthcare Bridge', icon: '🏥' },
        ],
    },
];

export function Sidebar({ isMobileOpen, onMobileClose, onThemeToggle, isDarkTheme }: SidebarProps) {
    const { signOut } = useAuth();

    return (
        <aside className={`${styles.sidebar} ${isMobileOpen ? styles.mobileOpen : ''}`}>
            <div className={styles.brand}>
                <div className={styles.logo}>
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                        <circle cx="14" cy="14" r="12" stroke="currentColor" strokeWidth="2" />
                        <path d="M8 14h12M14 8v12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                </div>
                <div className={styles.brandText}>
                    <span className={styles.brandName}>Expat Horizon</span>
                    <span className={styles.brandSub}>Cross-Border Finance</span>
                </div>
            </div>

            <nav className={styles.nav}>
                {navGroups.map((group) => (
                    <div key={group.label} className={styles.navGroup}>
                        <span className={styles.groupLabel}>{group.label}</span>
                        <ul className={styles.navList}>
                            {group.items.map((item) => (
                                <li key={item.path}>
                                    <NavLink
                                        to={item.path}
                                        className={({ isActive }) =>
                                            `${styles.navItem} ${isActive ? styles.active : ''}`
                                        }
                                        onClick={onMobileClose}
                                    >
                                        <span className={styles.navIcon}>{item.icon}</span>
                                        <span className={styles.navLabel}>{item.label}</span>
                                    </NavLink>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </nav>

            <div className={styles.bottomSection}>
                {onThemeToggle && (
                    <div className={styles.themeToggle}>
                        <button
                            className={`${styles.themeToggleBtn} ${isDarkTheme ? styles.dark : ''}`}
                            onClick={onThemeToggle}
                            aria-label="Toggle theme"
                        >
                            <span className={styles.toggleIcon}>☀️</span>
                            <span className={styles.togglePill} />
                            <span className={styles.toggleIcon}>🌙</span>
                        </button>
                    </div>
                )}
                <ul className={styles.navList}>
                    <li>
                        <button className={styles.navItem} onClick={signOut}>
                            <span className={styles.navIcon}>⏻</span>
                            <span className={styles.navLabel}>Sign Out</span>
                        </button>
                    </li>
                </ul>
            </div>
        </aside>
    );
}
